import { useState } from "react";
import axios from "axios";
import { Card, List } from "antd";
import ModelDetail from "./ModelDetail";
import envConfig from "../config.json";
import { useMsal } from "@azure/msal-react";

/**
 * Component used to show model list
 * @param {*} props properties of the component
 * @returns
 */
const ListModel = (props) => {
  const { instance } = useMsal();
  const { fetchModels } = props;
  const [showDetail, setShowDetail] = useState(false);
  const [title, setTitle] = useState("");
  const [showProgress, setShowProgress] = useState(false);
  const [gltfUrl, setGltfUrl] = useState("");
  const [model, setModel] = useState([]);
  const [assetId, setAssetId] = useState("");
  const [curVer, setCurVer] = useState();

  /**
   * Function to handle the show modal
   * @param {*} item selected Item/model
   */
  const showModal = (item) => {
    setShowDetail(true);
    setTitle(item.title);
    setAssetId(item.assetId);
    getModelDetail(item.assetId);
  };
  /**
   * Fuction used to handle close the model
   */
  const closeModel = () => {
    setShowDetail(false);
    setGltfUrl("");
  };
  /**
   * Function used to get the model details
   * @param {*} assetId the model asset id
   */
  const getModelDetail = (assetId) => {
    setShowProgress(true);
    const msalToken = localStorage.getItem("msal.accesstoken");
    const token3DCE = localStorage.getItem("accesstokence");
    const config = {
      headers: {
        Authorization: `Bearer ${msalToken}`,
        authorization_token: token3DCE,
      },
    };
    axios
      .get(
        `${envConfig.aotmwapi}/api/3d-cms/continuumengine/${assetId}`,
        config
      )
      .then((response) => {
        setShowProgress(false);
        const res = response.data;
        setModel(res);
        let lastElement = res.versions[res.versions.length - 1];
        setCurVer(lastElement);
        lastElement = lastElement.assets.filter(function (x) {
          return x.format === "glb" || x.format === "gltf";
        });
        if (lastElement.length !== 0) {
          setGltfUrl(lastElement[0].url);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          localStorage.removeItem("checkRole");
          const logoutRequest = {
            postLogoutRedirectUri: envConfig.redirectUri,
          };
          instance.logoutRedirect(logoutRequest);
        }
        console.error("error in getModelDetail");
      });
  };

  return (
    <>
      <List
        className="listPadding"
        grid={{
          gutter: 16,
          column: 4,
          xs: 1,
          sm: 2,
          md: 3,
          lg: 4,
        }}
        dataSource={props.models}
        renderItem={(item) => (
          <List.Item className="listItemBackground">
            <Card
              onClick={() => showModal(item)}
              title={item.title}
              headStyle={{ backgroundColor: "#202633", border: 0 }}
              bodyStyle={{
                padding: 8,
                borderTop: "0px solid #202633",
              }}
            >
              <div className="imageframe">
                <img
                  alt="example"
                  src={
                    item.thumbnailUrl === ""
                      ? "/aotLogo.png"
                      : item.thumbnailUrl
                  }
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "/aotLogo.png";
                  }}
                  className="preview"
                />
              </div>
            </Card>
          </List.Item>
        )}
      />
      <ModelDetail
        showDetail={showDetail}
        title={title}
        model={model}
        showProgress={showProgress}
        gltfUrl={gltfUrl}
        assetId={assetId}
        curVer={curVer}
        closeModel={closeModel}
        fetch3DCEModels={fetchModels}
        page="3dce"
      ></ModelDetail>
    </>
  );
};
export default ListModel;
